import {
  MASTER_SIM_LIST,
  MASTER_SIM_LIST_SUCCESS,
  MASTER_SIM_LIST_FAILURE,
  MASTER_SIM_DATA,
  MASTER_SIM_DATA_SUCCESS,
  MASTER_SIM_DATA_FAILURE,
  MASTER_SIM_COMPANIES,
  MASTER_SIM_COMPANIES_SUCCESS,
  MASTER_SIM_COMPANIES_FAILURE,
  MASTER_SIM_CREATE,
  MASTER_SIM_CREATE_SUCCESS,
  MASTER_SIM_CREATE_FAILURE,
  MASTER_SIM_UPDATE,
  MASTER_SIM_UPDATE_SUCCESS,
  MASTER_SIM_UPDATE_FAILURE,
  MASTER_SIM_DELETE,
  MASTER_SIM_DELETE_SUCCESS,
  MASTER_SIM_DELETE_FAILURE,
  MASTER_SIM_SYNC,
  MASTER_SIM_SYNC_SUCCESS,
  MASTER_SIM_SYNC_FAILURE,
  MASTER_SIM_REGISTER,
  MASTER_SIM_REGISTER_SUCCESS,
  MASTER_SIM_REGISTER_FAILURE,
  MASTER_SIM_ACTIVATE,
  MASTER_SIM_ACTIVATE_SUCCESS,
  MASTER_SIM_ACTIVATE_FAILURE,
  MASTER_SIM_SUSPEND,
  MASTER_SIM_SUSPEND_SUCCESS,
  MASTER_SIM_SUSPEND_FAILURE,
  MASTER_SIM_ASSIGN,
  MASTER_SIM_ASSIGN_SUCCESS,
  MASTER_SIM_ASSIGN_FAILURE,
  MASTER_SIM_UNASSIGN,
  MASTER_SIM_UNASSIGN_SUCCESS,
  MASTER_SIM_UNASSIGN_FAILURE,
} from "./actionType";

const initialState = {
  // LIST
  masterSimList: [],
  masterSimListLoading: false,
  masterSimListError: null,

  // DATA (single SIM + assignment history)
  masterSimData: {},
  masterSimDataLoading: false,
  masterSimDataError: null,

  // COMPANIES (assign-to dropdown)
  masterSimCompanies: [],
  masterSimCompaniesLoading: false,
  masterSimCompaniesError: null,

  // CREATE
  masterSimCreate: {},
  masterSimCreateLoading: false,
  masterSimCreateError: null,

  // UPDATE
  masterSimUpdate: {},
  masterSimUpdateLoading: false,
  masterSimUpdateError: null,

  // DELETE
  masterSimDelete: {},
  masterSimDeleteLoading: false,
  masterSimDeleteError: null,

  // SYNC
  masterSimSync: {},
  masterSimSyncLoading: false,
  masterSimSyncError: null,

  // REGISTER (emnify batch by BIC)
  masterSimRegister: {},
  masterSimRegisterLoading: false,
  masterSimRegisterError: null,

  // ACTIVATE / SUSPEND
  masterSimActionLoading: false,
  masterSimActionError: null,

  // ASSIGN / UNASSIGN
  masterSimAssignLoading: false,
  masterSimAssignError: null,
};

const masterSimReducer = (state = initialState, action) => {
  switch (action.type) {
    // LIST
    case MASTER_SIM_LIST:
      return { ...state, masterSimListLoading: true, masterSimListError: null };
    case MASTER_SIM_LIST_SUCCESS:
      return { ...state, masterSimList: action.payload, masterSimListLoading: false };
    case MASTER_SIM_LIST_FAILURE:
      return { ...state, masterSimListLoading: false, masterSimListError: action.payload };

    // DATA
    case MASTER_SIM_DATA:
      return { ...state, masterSimDataLoading: true, masterSimDataError: null };
    case MASTER_SIM_DATA_SUCCESS:
      return { ...state, masterSimData: action.payload, masterSimDataLoading: false };
    case MASTER_SIM_DATA_FAILURE:
      return { ...state, masterSimDataLoading: false, masterSimDataError: action.payload };

    // COMPANIES
    case MASTER_SIM_COMPANIES:
      return { ...state, masterSimCompaniesLoading: true, masterSimCompaniesError: null };
    case MASTER_SIM_COMPANIES_SUCCESS:
      return { ...state, masterSimCompanies: action.payload, masterSimCompaniesLoading: false };
    case MASTER_SIM_COMPANIES_FAILURE:
      return { ...state, masterSimCompaniesLoading: false, masterSimCompaniesError: action.payload };

    // CREATE
    case MASTER_SIM_CREATE:
      return { ...state, masterSimCreateLoading: true, masterSimCreateError: null };
    case MASTER_SIM_CREATE_SUCCESS:
      return { ...state, masterSimCreate: action.payload, masterSimCreateLoading: false };
    case MASTER_SIM_CREATE_FAILURE:
      return { ...state, masterSimCreateLoading: false, masterSimCreateError: action.payload };

    // UPDATE
    case MASTER_SIM_UPDATE:
      return { ...state, masterSimUpdateLoading: true, masterSimUpdateError: null };
    case MASTER_SIM_UPDATE_SUCCESS:
      return { ...state, masterSimUpdate: action.payload, masterSimUpdateLoading: false };
    case MASTER_SIM_UPDATE_FAILURE:
      return { ...state, masterSimUpdateLoading: false, masterSimUpdateError: action.payload };

    // DELETE
    case MASTER_SIM_DELETE:
      return { ...state, masterSimDeleteLoading: true, masterSimDeleteError: null };
    case MASTER_SIM_DELETE_SUCCESS:
      return { ...state, masterSimDelete: action.payload, masterSimDeleteLoading: false };
    case MASTER_SIM_DELETE_FAILURE:
      return { ...state, masterSimDeleteLoading: false, masterSimDeleteError: action.payload };

    // SYNC
    case MASTER_SIM_SYNC:
      return { ...state, masterSimSyncLoading: true, masterSimSyncError: null };
    case MASTER_SIM_SYNC_SUCCESS:
      return { ...state, masterSimSync: action.payload, masterSimSyncLoading: false };
    case MASTER_SIM_SYNC_FAILURE:
      return { ...state, masterSimSyncLoading: false, masterSimSyncError: action.payload };

    // REGISTER
    case MASTER_SIM_REGISTER:
      return { ...state, masterSimRegisterLoading: true, masterSimRegisterError: null };
    case MASTER_SIM_REGISTER_SUCCESS:
      return { ...state, masterSimRegister: action.payload, masterSimRegisterLoading: false };
    case MASTER_SIM_REGISTER_FAILURE:
      return { ...state, masterSimRegisterLoading: false, masterSimRegisterError: action.payload };

    // ACTIVATE
    case MASTER_SIM_ACTIVATE:
    case MASTER_SIM_SUSPEND:
      return { ...state, masterSimActionLoading: true, masterSimActionError: null };
    case MASTER_SIM_ACTIVATE_SUCCESS:
    case MASTER_SIM_SUSPEND_SUCCESS:
      return { ...state, masterSimActionLoading: false };
    case MASTER_SIM_ACTIVATE_FAILURE:
    case MASTER_SIM_SUSPEND_FAILURE:
      return { ...state, masterSimActionLoading: false, masterSimActionError: action.payload };

    // ASSIGN / UNASSIGN
    case MASTER_SIM_ASSIGN:
    case MASTER_SIM_UNASSIGN:
      return { ...state, masterSimAssignLoading: true, masterSimAssignError: null };
    case MASTER_SIM_ASSIGN_SUCCESS:
    case MASTER_SIM_UNASSIGN_SUCCESS:
      return { ...state, masterSimAssignLoading: false };
    case MASTER_SIM_ASSIGN_FAILURE:
    case MASTER_SIM_UNASSIGN_FAILURE:
      return { ...state, masterSimAssignLoading: false, masterSimAssignError: action.payload };

    default:
      return state;
  }
};

export default masterSimReducer;
